import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  loaderForPopUp: false,
};

const loadingSlice = createSlice({
  name: "data_loading",
  initialState,
  reducers: {
    setLoading: (state, action) => ({
      ...state,
      loading: action.payload,
    }),
    setLoadingForPopUp: (state, action) => ({
      ...state,
      loaderForPopUp: action.payload,
    }),
  },
});

export const { setLoading, setLoadingForPopUp } = loadingSlice.actions;

export default loadingSlice.reducer;
